import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { AppComponent } from '../../../app.component';

@Component({
  selector: 'anon-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditorComponent {
  @Input() story: any;
  @Input() config: any;
  @Input() ready: any;
  @Output() readyChange = new EventEmitter<any>();
  @Output() editorChange = new EventEmitter<ChangeEvent>();
  public Editor: any;

  constructor() {
    if (AppComponent.isBrowser) {
      const CustomEditor = require("./CustomEditorSuperBuild/ckeditor");
      this.Editor = CustomEditor.CustomBalloonEditor;
    }
  }

  onReady(ready_event: any) { this.readyChange.emit(ready_event); }
  onChange(change_event: ChangeEvent) { this.editorChange.emit(change_event); }
}
